// Preset markers
var defaultSize = [34, 50];
var defaultIconAnchor = [17, 50];
var defaultPopupAnchor = [0, 0];


var markerParking = L.icon({
    iconUrl: '_resources/ccc-maps/client/images/markers/P-blue.png',

    iconSize: defaultSize, // size of the icon
    iconAnchor: defaultIconAnchor, // point of the icon which will correspond to marker's location
    popupAnchor: defaultPopupAnchor // point from which the popup should open relative to the iconAnchor
});

var markerPmobility = L.icon({
    iconUrl: '_resources/ccc-maps/client/images/markers/Pdisabled-blue.png',

    iconSize: defaultSize, // size of the icon
    iconAnchor: defaultIconAnchor, // point of the icon which will correspond to marker's location
    popupAnchor: defaultPopupAnchor // point from which the popup should open relative to the iconAnchor
});

var markerPmotorcycle = L.icon({
    iconUrl: '_resources/ccc-maps/client/images/markers/Pmotorcycle-blue.png',

    iconSize: defaultSize, // size of the icon
    iconAnchor: defaultIconAnchor, // point of the icon which will correspond to marker's location
    popupAnchor: defaultPopupAnchor // point from which the popup should open relative to the iconAnchor
});